// 用户信息包含  userId, customerId, customerDetails
const initState: any = {}
const customer = (state = initState, action: any = {}) => {
  switch (action.type) {
    case "UPDATE_CUSTOMER_INFO":
      return { ...state, ...action.payload }
    default:
      return state
  }
}

export default customer
